var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{attrs:{"type":_vm.type,"icon-left":_vm.icon,"label":_vm.label,"size":_vm.size},on:{"click":_vm.openModal}}),_vm._v(" "),_c('o-modal',{attrs:{"title":_vm.title,"isOpen":_vm.showModal},on:{"closeModal":_vm.closeModal,"confirmModalAction":_vm.confirmModalAction}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }